import * as BtnC from "./_cccBtnC";
import * as GridC from "./_cccGridC";
import { a } from "./_cmABT";
import * as _cr from "./_cr";
import * as _ht from "./_ht";

/*
const $abtz = {
  btnSchz: {
    type: 'ctd',
    br: 3.5,
    dh: 3.5,
    dw: 15,
    tc: 'lt1',
    text: '検索',
    ts: 'm',
    sc: 'lt5',
  },
}
*/

export const N = (pz: {
  sPz: _ht.dz,
  abtz?: {
    btnSchz?: _ht.dz,
    gridSchz?: _ht.dz,
  }
  schClds: _ht.ls,
  onSch: () => void,
}) => {
  return (
    _cr.c(GridC.N, {
      abtz: pz.abtz?.gridSchz,
      boxStlz: a(`dw/f`), // dw は ccmRootC で調整
      lineCs: [
        {
          boxStlz: a(`dw/f mb/1`),
          cellCs: [
            {
              boxStlz: a(`dw/f fd/rss fw/w`),
              boxClds: pz.schClds,
            },
          ]
        },
        {
          boxStlz: a(`dw/f f/n fd/ccc`),
          cellCs: [
            {
              boxClds: [
                _cr.c(BtnC.N, {
//                  abtz: pz.abtz?.btnSchz ?? $abtz.btnSchz,
                  abtz: pz.abtz?.btnSchz,
                  frmCz: {
                    pslPtyz: {
                      onPrs: pz.onSch,
                    },
                  }
                }),

              ]
            },
          ]
        },
      ]
    })
  );
};
